import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSquarePlus: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"square-plus, add"} maskId="square-filled-radius-0-stroke-1-IconSquarePlus"><path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H3V3ZM12.5 8.00736L11.5 8.00736L11.5 11.5H8.00735V12.5H11.5V15.9926L12.5 15.9926V12.5H15.9926V11.5L12.5 11.5V8.00736Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSquarePlus;
